import React from 'react';

const BrandCard = (props) => {
    
    return (
        <>
            <div className={props.classes.Brands_card}>
                <div>
                    {/*<img src={brand.image} alt={brand.name}/>*/}
                    <img src={props.brand.image_icon} alt={props.brand.name}/>
                </div>
                <div>
                    <div className={props.classes.separator}/>
                </div>
                <div>
                    <h4 className="jbfs-title-case">{props.brand.name.toUpperCase()}</h4>
                    <div className={["jbfs-description", props.classes.Brands_description].join(' ')}>
                        <p dangerouslySetInnerHTML={{__html: props.brand.description}}/>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BrandCard